import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Text, IconEdit } from "braid-design-system";
import isEmpty from "lodash/isEmpty.js";
import { translations } from "../../../components/.vocab/index.mjs";
import { AddAssetButton } from "../BrandCard/BrandCardWithAssetLibrary.mjs";
import { Logo } from "./Logo/Logo.mjs";
import { root, selected, selectable, placeholder, backgroundPlaceholder, rootJdp, rootSerp, rootAssetLibrary } from "./BrandLogo.css.mjs";
const ReplaceLogo = ({ onClick }) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
    Box,
    {
      cursor: "pointer",
      component: "button",
      paddingTop: "small",
      "data-testid": "bx-edit-logo-button",
      onClick,
      children: /* @__PURE__ */ jsxs(Text, { tone: "link", children: [
        /* @__PURE__ */ jsx(IconEdit, { alignY: "lowercase" }),
        " ",
        t("Replace")
      ] })
    }
  ) });
};
const BrandLogo = ({
  logo,
  selected: selected$1 = false,
  selectable: selectable$1 = false,
  isEditMode = false,
  onAddLogoClick,
  onReplaceLogoClick,
  directUrl = "",
  withPlaceholder = false,
  showLoading = false,
  placement = "jdp",
  experimentBrandId = ""
}) => {
  const { t } = useTranslations(translations);
  const hasLogo = !isEmpty(logo) || Boolean(directUrl.length);
  if (!hasLogo && !isEditMode) {
    return null;
  }
  const placementStyles = {
    jdp: {
      root: rootJdp
    },
    serp: {
      root: rootSerp
    },
    brandCard: {
      root: rootSerp
    },
    assetLibrary: {
      root: rootAssetLibrary
    }
  }[placement];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        className: [
          root,
          placementStyles.root,
          {
            [selected]: selectable$1 && selected$1,
            [selectable]: selectable$1
          }
        ],
        "data-testid": "bx-logo-container",
        height: "full",
        children: [
          !hasLogo && isEditMode && !showLoading && /* @__PURE__ */ jsx(
            Box,
            {
              paddingX: ["xxsmall", "small"],
              height: "full",
              width: "full",
              className: [
                {
                  [placeholder]: true,
                  [backgroundPlaceholder]: withPlaceholder
                }
              ],
              children: /* @__PURE__ */ jsx(
                AddAssetButton,
                {
                  label: t("Add logo"),
                  dataTestId: "bx-add-logo",
                  onClick: onAddLogoClick
                }
              )
            }
          ),
          (hasLogo || showLoading) && /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", height: "full", children: /* @__PURE__ */ jsx(
            Logo,
            {
              asset: logo,
              selectable: selectable$1,
              directUrl,
              withPlaceholder,
              showLoading,
              placement,
              experimentBrandId
            }
          ) })
        ]
      }
    ),
    hasLogo && isEditMode && /* @__PURE__ */ jsx(ReplaceLogo, { onClick: onReplaceLogoClick })
  ] });
};
export {
  BrandLogo
};
